import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { AuthProvider } from "./accounts/context/AuthProvider";
import { HelpProvider } from "./components/shared/context/HelpProvider";
import { AuditProvider } from "./components/shared/context/AuditProvider";
import { MoamadProvider } from "./components/shared/context/MoamadContext";
import { ExtDateDocumentProvider } from "./components/shared/context/ExtentionDocumentsContext";
import { MoamadsBetweenDatesProvider } from "./components/shared/context/MoamadsBetweenDatesContext";
import { BrowserRouter } from "react-router-dom";

const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
link.rel = 'icon';
link.href = '/icon.png';
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <BrowserRouter>
    <AuthProvider>
      <HelpProvider>
        <AuditProvider>
          <MoamadProvider>
            <ExtDateDocumentProvider>
              <MoamadsBetweenDatesProvider>
                <App />
              </MoamadsBetweenDatesProvider>
            </ExtDateDocumentProvider>
          </MoamadProvider>
        </AuditProvider>
      </HelpProvider>
    </AuthProvider>
  </BrowserRouter>
);

//
